import { ContactEdit } from '@client/components/contacts/ContactEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/console/$orgId/configuration/vendor-management/suppliers/list/details/$id/contacts/add',
)({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'New contact',
        },
    },

    component: RouteComponent,
});

function RouteComponent() {
    return <ContactEdit action={['add']} type="SUPPLIER" entity="supplier" entityId={Route.useParams().id} />;
}
